import SafeLocalStorage from "../utils/SafeLocalStorage";

/**
 * Service for handling promo code caching operations
 */
class PromoCacheService {
  private static readonly PROMO_CODE_KEY = "cachedPromoCode";

  /**
   * Save promo code to localStorage
   * @param code - The promo code to cache
   */
  static savePromoCode(code: string): void {
    SafeLocalStorage.setItem(this.PROMO_CODE_KEY, code);
  }

  /**
   * Get cached promo code from localStorage
   * @returns The cached promo code or null if not found
   */
  static getPromoCode(): string | null {
    return SafeLocalStorage.getItem(this.PROMO_CODE_KEY);
  }

  /**
   * Remove cached promo code from localStorage
   */
  static removePromoCode(): void {
    SafeLocalStorage.removeItem(this.PROMO_CODE_KEY);
  }
}

export default PromoCacheService;
